export default __webpack_public_path__ + "static/media/icon_matchbox.555932c1.svg";